import { useState } from "react";
import { TaleBorderFul } from "@components/TaleBorderFul";

export const TaleTextarea = ({
  value,
  onChange,
  width = "100%",
  height = 51,
  role = "normal",
  label = "",
  labelClassName = "",
  className = "",
  textareaClassName = "",
  customBorder = "",
  ...props
}) => {
  const [focused, setfocused] = useState(false);
  return (
    <div
      className={`flex h-full w-full flex-col ${label ? "gap-1" : ""} ${
        className ?? ""
      }`}
    >
      {!label ? null : (
        <span className={`font-semibold text-sm ${labelClassName ?? ""}`}>
          {label}
        </span>
      )}
      <TaleBorderFul
        role={role}
        width={width}
        height={height}
        customBackground={
          customBorder || (!focused && !value ? "bg-[#ddd]" : null)
        }
        className="!grow !size-full"
      >
        <textarea
          onFocus={() => setfocused(true)}
          onBlur={() => setfocused(false)}
          className={`!z-10 !w-full !h-full outline-none transition-all ${
            !focused && !value ? "bg-[#ddd]" : "bg-white"
          } rounded-none px-2 ${textareaClassName ?? ""}`}
          value={value}
          onChange={onChange}
          {...props}
        />
      </TaleBorderFul>
      {props.maxLength ? (
        <div
          style={{
            color: "rgba(0, 0, 0, 0.30)",
            fontSize: 12,
            fontFamily: "revert",
            fontWeight: "600",
            lineHeight: 1,
            wordWrap: "break-word",
          }}
        >
          {value.length}/{props.maxLength}
        </div>
      ) : null}
    </div>
  );
};
